import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  noMatchingRecords: {
    color: theme.palette.text.secondary,
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(6),
    fontStyle: 'italic'
  }
}));
const NoteEmptyPageMessage: React.FC = () => {
  const classes = useStyles();
  return (
    <Typography
      variant="body2"
      className={classes.noMatchingRecords}
      data-testid="noMatchingNotes"
    >
      <FormattedMessage id={'note.empty.noMatchingNotes'} />
    </Typography>
  );
};

export default NoteEmptyPageMessage;
